import { cva, type VariantProps } from "class-variance-authority";

export type TooltipContentVariants = VariantProps<
  typeof tooltipContentVariants
>;
export const tooltipContentVariants = cva(
  "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit rounded-md px-3 py-1.5 text-xs text-balance",
  {
    variants: {
      color: {
        default: "bg-primary text-primary-content",
        danger: "bg-danger text-danger-content",
      },
    },
    defaultVariants: {
      color: "default",
    },
  },
);

export const tooltipContentArrowVariants = cva(
  " z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]",
  {
    variants: {
      color: {
        default: "bg-primary fill-primary",
        danger: "bg-danger fill-danger",
      },
    },
  },
);
